import { useRouter } from 'next/router'
import { isEmpty, isNil } from 'ramda'

import type { Article } from '@twisto/api-cms'

import {
  ContentNavigationChildren,
  ContentNavigationParent,
} from 'homepage/components/molecules'

import { isCurrentSubtree } from './helpers'

type Props = {
  articles: Article[]
}

export const CategoryContentNavigationArticles = ({ articles }: Props) => {
  const { asPath } = useRouter()

  // skip this component if current subtree doesn't own articles
  if (isNil(articles) || isEmpty(articles)) {
    return null
  }

  return (
    <ContentNavigationParent>
      {articles.map((article: Article, index) => {
        if (
          isNil(article) ||
          isNil(article.headline) ||
          isNil(article.path) ||
          isNil(article.publishedAt)
        ) {
          return null
        }

        const { headline, path } = article

        return (
          <ContentNavigationChildren
            key={index}
            href={path}
            isCurrent={isCurrentSubtree(path, asPath)}
            label={headline}
          />
        )
      })}
    </ContentNavigationParent>
  )
}
